import { render, staticRenderFns } from "./DiscountTemplate.vue?vue&type=template&id=0e26682e&scoped=true&"
import script from "./DiscountTemplate.vue?vue&type=script&lang=js&"
export * from "./DiscountTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e26682e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e26682e')) {
      api.createRecord('0e26682e', component.options)
    } else {
      api.reload('0e26682e', component.options)
    }
    module.hot.accept("./DiscountTemplate.vue?vue&type=template&id=0e26682e&scoped=true&", function () {
      api.rerender('0e26682e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/DiscountTemplate.vue"
export default component.exports